import React from 'react';

interface ChevronDownIconProps {
  size?: number;
  color?: string;
}

export const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({ 
  size = 16, 
  color = '#191F2E' 
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.44 5.44C3.62 5.26 3.88 5.26 4.06 5.44L8 9.38L11.94 5.44C12.12 5.26 12.38 5.26 12.56 5.44C12.74 5.62 12.74 5.88 12.56 6.06L8.31 10.31C8.13 10.49 7.87 10.49 7.69 10.31L3.44 6.06C3.26 5.88 3.26 5.62 3.44 5.44Z"
      fill={color}
    />
  </svg>
);
